import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54a855b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "panel-heading" }
const _hoisted_3 = { class: "field is-horizontal" }
const _hoisted_4 = { class: "field-label is-normal" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "field-body" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "help" }
const _hoisted_11 = {
  key: 0,
  class: "field is-horizontal"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label is-normal" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Emoji")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "field-body" }
const _hoisted_15 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_16 = {
  key: 1,
  class: "field is-horizontal"
}
const _hoisted_17 = { class: "field-label is-normal" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "field-body" }
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = { class: "field is-horizontal" }
const _hoisted_22 = { class: "field-label is-normal" }
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "field-body" }
const _hoisted_25 = { class: "control" }
const _hoisted_26 = { class: "select is-fullwidth" }
const _hoisted_27 = { value: "weiblich" }
const _hoisted_28 = { value: "männlich" }
const _hoisted_29 = { value: "divers" }
const _hoisted_30 = { value: "nicht festgelegt" }
const _hoisted_31 = { class: "field is-horizontal" }
const _hoisted_32 = { class: "field-label is-normal" }
const _hoisted_33 = { class: "label" }
const _hoisted_34 = { class: "field-body" }
const _hoisted_35 = { class: "field" }
const _hoisted_36 = { class: "control" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "field" }
const _hoisted_39 = { class: "control" }
const _hoisted_40 = ["value", "placeholder"]
const _hoisted_41 = { class: "field is-grouped is-grouped-centered" }
const _hoisted_42 = { class: "control" }
const _hoisted_43 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t("ego")), 1)
    ]),
    _createElementVNode("form", {
      class: "panel-block form",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editEgoFinished && _ctx.editEgoFinished(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t("name")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { 'is-danger': _ctx.invalidName }]),
                ref: "egofield",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.egoName) = $event)),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.commitEdit($event, 'name'))),
                type: "text",
                placeholder: _ctx.t('whoisinthecenter')
              }, null, 42, _hoisted_9), [
                [_vModelText, _ctx.egoName]
              ])
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t("mandatoryfield")), 1)
          ])
        ])
      ]),
      (_ctx.emoji)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.selectedEmoji == null || _ctx.selectedEmoji.length < 1
                    ? _ctx.t("noemoji")
                    : _ctx.selectedEmoji), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.emoji)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("selectEmoji")), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["dropdown", { 'is-active': _ctx.showEmojiPicker }])
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "button is-small",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleEmojiPicker && _ctx.toggleEmojiPicker(...args)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("selectemoji")), 1)
                  ]),
                  (_ctx.selectedEmoji != null && _ctx.selectedEmoji.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeEmoji && _ctx.removeEmoji(...args))),
                        class: "button is-small",
                        style: {"margin-left":"10px"}
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t("removeemoji")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_EmojiPicker, {
                        modelValue: _ctx.selectedEmoji,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedEmoji) = $event)),
                        native: true,
                        disableSkinTones: true,
                        onSelect: _ctx.onSelectEmoji
                      }, null, 8, ["modelValue", "onSelect"])
                    ])
                  ])
                ])
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("genders")), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.egoGender) = $event))
              }, [
                _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.t("female")), 1),
                _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.t("male")), 1),
                _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.t("diverse")), 1),
                _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.t("notspecified")), 1)
              ], 512), [
                [_vModelSelect, _ctx.egoGender]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("age")), 1)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("input", {
                class: "input",
                min: "0",
                value: _ctx.egoAge,
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.commitEdit($event, 'age'))),
                type: "number"
              }, null, 40, _hoisted_37)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("textarea", {
            class: "textarea is-small",
            value: _ctx.egoNote,
            onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.commitEdit($event, 'note'))),
            placeholder: _ctx.t('notesaboutego')
          }, null, 40, _hoisted_40)
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("p", _hoisted_42, [
          _createElementVNode("button", {
            class: "button is-primary",
            disabled: _ctx.invalidName
          }, _toDisplayString(_ctx.t("done")), 9, _hoisted_43)
        ])
      ])
    ], 32)
  ]))
}